import React, { useRef } from 'react'
import { useNavigate } from "react-router";
import { get_sales_w_so_row_data_list } from './SalesWSOSlice';
import { SalesWSOFilterAPICall, viewSalesWSOAPICall } from './SalesWSOAPI';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import store from '../../../../../Redux/store';
import { useEffect } from 'react';
import { IconButton, Skeleton, Tooltip } from '@mui/material';
import { convertDateFormat, getCurrentTime } from '../../../../../Js/Date';
import paidRibbon from "../../../../../Assets/statusRibbon/paid.png"
import CategorySearchandFilter from '../../../../Single Components/CategorySearchandFilter';
import CustomPagination from '../../../../Single Components/CustomPagination';
import axios from 'axios';
import { setFilterActive } from '../../../../Single Components/listSlice/filterCategorySlice';
import ReactToPrint from 'react-to-print';
import ExcelJS from "exceljs";
import TableListActionButtons from '../../../../Single Components/ActionButtons/TableListActionButtons';
import PrintComponentList from "../../../SalesNew/SalesReport/TableListPrint"

export const SalesWSO = () => {

  const userRole = useSelector((state) => state.userRoleSlice.value)
  const userBranchId = localStorage.getItem("branchId")
  const filtereDataOptions = useSelector((state) => state.listCategory);
  const tableListData = useSelector((state) => state.salesWSOSlice.apiResList);
  const [isLoading, setIsLoading] = useState(false)
  const [FormDataInfo, setFormDataInfo] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const totalPages = tableListData?.pages;
  const [filteredDatas, setFilteredData] = useState({});
     const printRef = useRef(); 

  let navigate = useNavigate();

  const createFunctuon = () => {
    navigate("/userdashboard/accounts/customers/saleswso/create")
  }
  const handlePageChange = (page) => {

    setCurrentPage(page);
  };
  const handleBranchSelect = (selectedBranch) => {
    setSelectedBranch(selectedBranch);

  };
  const handleClickRow = (row) => {
    localStorage.setItem("singleViewById", row._id);
    store.dispatch(setFilterActive(window.location.pathname))
    navigate("/userdashboard/accounts/customers/saleswso/singleView")
  }
  const handleDataFromChild = (data) => {
    setFormDataInfo(data)
  };
  const handleFilterChange = (updatedItems) => {
    setFilteredData(updatedItems);
  }
  const formatFilterInfo = (filters) => {
    const parts = [];

    if (filters?.toDate && filters.fromDate) {
      parts.push(`As of ${filters.fromDate} to ${filters?.toDate}`);
    }
    if (filters?.branchList) {
      parts.push(
        `Branch: ${filters?.branchList?.storeCode}-${filters?.branchList?.branchName}`
      );
    }
    if (filters?.location) {
      parts.push(`location: ${filters?.location?.name}`);
    }
    if (filters?.toLocation) {
      parts.push(`To Location: ${filters?.toLocation?.name}`);
    }
    if (filters?.status) {
      parts.push(`status: ${filters?.status}`);
    }
    if (filters?.createdBy) {
      parts.push(`createdBy: ${filters?.createdBy?.staff_name}`);
    }
    return parts; // Return the array directly
  };
  const downloadList = () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Sales WSO");
    sheet.properties.defaultRowHeight = 20;

    // Add header section
    const titleRow = sheet.addRow(["Sales WSO"]);
    titleRow.font = { size: 15, bold: true };
    sheet.mergeCells("A1:H1");
    titleRow.getCell(1).alignment = {
      vertical: "middle",
      horizontal: "center",
    };

    // Add additional header information
    const filterParts = formatFilterInfo(filteredDatas) || [];

    // Ensure filterParts is an array and iterate over it
    if (Array.isArray(filterParts)) {
      filterParts.forEach((part, index) => {
        const row = sheet.addRow([part]);
        row.font = { size: 11, bold: true };
        sheet.mergeCells(`A${index + 2}:H${index + 2}`);
        row.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
      });
    }

    // Add an empty row between header and table
    sheet.addRow([]);

    // Header row styling
    const headerRow = sheet.addRow([
      "Date",
      "Name",
      "Customer",
      "Invoice Date",
      "Invoice Reference",
      "Total",
      "Created By",
      "Status",

    ]);
    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFedf2f9" }, // Use full hex code with "FF" prefix for better compatibility
    };
    const headerFont = {
      size: 12,
      bold: true,
      color: { argb: "FF000000" }, // White font color
    };

    headerRow.eachCell((cell, colNumber) => {
      cell.fill = headerFill;
      cell.font = headerFont;
      cell.alignment = { vertical: "middle", horizontal: "center" }; // Ensure header text is centered
    });

    sheet.columns = [
      { header: "Date", key: "billDate", width: 10 },
      { header: "Name", key: "sequenceName", width: 20 },
      { header: "Customer", key: "vendorName", width: 25 },
      { header: "Invoice Date", key: "billDate", width: 25 },
      { header: "Invoice Reference", key: "billRef", width: 25 },
      { header: "total", key: "total", width: 15 },
      { header: "Created By", key: "CREATEDBY", width: 15 },
      { header: "Sales WSO", key: "status", width: 20 },
    ];

    tableListData?.list?.forEach((item, index) => {
      const row = sheet.addRow({
        billDate: item?.billDate,
        sequenceName: item.sequenceName,
        vendorName: item.vendorName,
        billDate: convertDateFormat(item?.billDate),
        billRef: item?.billRef,
        total: item?.total,
        CREATEDBY: item?.CREATEDBY,
        status: item?.status,

      });

      const rowFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFFFF" }, // Use full hex code with "FF" prefix for better compatibility
      };

      row.eachCell((cell, colNumber) => {
        cell.fill = rowFill;
        cell.border = {
          //   top: { style: "thin", color: { argb: "FF000000" } },
          //   left: { style: "thin", color: { argb: "FF000000" } },
          bottom: { style: "thin", color: { argb: "FFedf2f9" } },
          //   right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        if (colNumber >= 1) {
          // Right align all columns except the first
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "Sales WSO.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };


  useEffect(() => {
    localStorage.removeItem("singleViewById");
    store.dispatch(get_sales_w_so_row_data_list({ salesWSOsingleData: undefined }))
  }, [])
  useEffect(() => {
    // const source = axios.CancelToken.source();
    if (FormDataInfo.length !== 0) {
      let loadData = window.location.pathname === filtereDataOptions?.filterActive
      !loadData &&
        SalesWSOFilterAPICall({
          paymentStatus: FormDataInfo.status.length !== 0 ? (FormDataInfo.status[0] === "PAID") : null,
          fromDate: FormDataInfo.fromDate === '' ? '' : `${FormDataInfo.fromDate} 00:00:00`,
          toDate: FormDataInfo.toDate === '' ? '' : `${FormDataInfo.toDate} 23:59:59`,
          location_id: FormDataInfo.location,
          branchList: FormDataInfo.branchList,
          status: FormDataInfo.status.length !== 0 ? (FormDataInfo.status[0] === "DRAFT" ? FormDataInfo.status : ["COMPLETED"]) : "",
          search: FormDataInfo.search,
          index: currentPage - 1,
        }, setIsLoading);
    }
    // return () => {
    //   source.cancel('Request canceled by cleanup');
    // };
  }, [FormDataInfo, currentPage]);


  return (
    <div className='global-page-parent-container updated-global-page-parent-container'>
      <div className="justify-space-between list-create-head-bar">
        <h3>Sales W/SO</h3>
        <div className="create-head-buttons-container">
          {/* <TableListActionButtons downloadClick={downloadList} /> */}
          <div className="justify-center" style={{ gap: "10px", width: "70%", justifyContent: "flex-end" }}>
             <PrintComponentList contentRef={printRef} />
             <Tooltip title="Download">
    <span>
        <IconButton
            style={{
                backgroundColor: "#ffd2d2",
                color: "#002995",
                borderRadius: "0",
                height: "38px",
                width: "37px",
            }}
            onClick={downloadList}
        >
            <i className="bi bi-arrow-down-circle"></i>
        </IconButton>
    </span>
</Tooltip>

           </div>
          <CategorySearchandFilter
            statusOptions={['DRAFT', 'POSTED', 'PAID']}
            onData={handleDataFromChild}
            isCreatedBy={true}
            isStatus={true}
            onBranchSelect={handleBranchSelect}
            onFilterChange={handleFilterChange}
          />
          <button onClick={createFunctuon} className='create-button-blue btn btn-primary'>Create</button>
        </div>
      </div>
      <div className="justify-space-between pagination-container">
        {FormDataInfo?.branchList?.length > 0 && (
          <h3>Branch name:
            {selectedBranch?.storeCode || filtereDataOptions?.filterCategorylist?.branchList?.storeCode}
            {selectedBranch?.branchName || filtereDataOptions?.filterCategorylist?.branchList?.branchName}</h3>
        )}
        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          setFormDataInfo={setFormDataInfo}
        />
      </div>

      <div className='new-global-table-container updated-table-container' ref={printRef}>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Customer</th>
              <th>Invoice Date</th>
              <th>Invoice Reference</th>
              <th>Total</th>
              <th>Created By</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody >
            {

              isLoading ? (
                [...Array(10)].map((r, i) => (
                  <tr key={i}>
                    <td colSpan={8}>
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={"100%"}
                        height={40}
                      />
                    </td>
                  </tr>
                ))
              ) :

                tableListData?.list !== undefined && tableListData?.list?.length !== 0 ? tableListData?.list?.slice(0)?.map((r, i) => (
                  <tr onClick={() => handleClickRow(r)}>
                    <td>{r?.billDate}</td>
                    <td>{r?.sequenceName || r?.NAME}</td>
                    <td>{r?.vendorName}</td>
                    <td>{convertDateFormat(r?.billDate)}</td>
                    <td>{r?.billRef}</td>
                    <td>{r?.total || "---"}</td>
                    <td>{r?.CREATEDBY || "---"}</td>
                    <td className='table-data-box'>
                      {r?.status === "DRAFT" ? (
                        <span className='draft'> DRAFT</span>
                      ) : r?.status === "POSTED" ? (
                        <span className='post'> POST</span>
                      ) : r?.status === "PAID" ? (
                        <span className='paid'>PAID</span>
                      ) : (
                        <span>{r?.status}</span>
                      )}
                    </td>
                  </tr>
                ))
                  :
                  <tr>
                    <td colSpan={8}>No Data</td>
                  </tr>
            }




          </tbody>
        </table>
      </div>

    </div>
  )
}
